"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AppMain',
  data: function data() {
    return {
      includeArr: ['appNewRenovation_hone', 'AppNewRenovationHone', 'newRenovation']
    };
  },
  computed: {
    key: function key() {
      return this.$route.path;
    }
  }
};